import LowPassFilter from '../filter/low-pass';

export function getAdcFilteredNoise(totalSpectralNoiseReferredToOutputArray, adcBandwidth, frequencyArray) {
  // var filter = LowPassFilter.create();
  var filterAmplitude = LowPassFilter.createFirstOrderFilterAmplitude(adcBandwidth, 1, frequencyArray);
  var result = filterAmplitude.map((item, index) => {
    return item.magnitude() * totalSpectralNoiseReferredToOutputArray[index];
  });

  return result;
}

export function getRmsNoise(totalSpectralNoiseReferredToOutputArray, adcBandwidth, frequencyArray) {
  var adcFilteredNoise = this.getAdcFilteredNoise(
    totalSpectralNoiseReferredToOutputArray,
    adcBandwidth,
    frequencyArray,
  );
  var rmsNoise = 0;
  for (var i = 1; i < frequencyArray.length; i++) {
    var frequencySpan = frequencyArray[i] - frequencyArray[i - 1];
    var noiseAverage = (adcFilteredNoise[i] + adcFilteredNoise[i - 1]) / 2;
    var noiseRootHz = noiseAverage * Math.sqrt(frequencySpan);
    rmsNoise = Math.sqrt(rmsNoise * rmsNoise + noiseRootHz * noiseRootHz);
  }

  return rmsNoise;
}

export function getPeakToPeak(rmsNoise) {
  return rmsNoise * 6.6;
}

export function getSNRandENOB(rmsNoise) {
  var ADC_RANGES = [1, 2, 5, 10];
  var result = ADC_RANGES.map((item) => {
    var maxsignal = item / (2 * Math.sqrt(2));
    var snr = (20 * Math.log(maxsignal / rmsNoise)) / Math.log(10);
    var enob = (snr - 1.76) / 6.02;
    return { adc: item, snr: snr, enob: enob };
  });

  return result;
}
